import {Route, Switch, useLocation} from "react-router-dom";
import React from "react";
import Login from "../views/Login";
import ResetPassword from "../views/ResetPassword";
import NewPassword from "../views/NewPassword";
import PasswordChanged from "../views/PasswordChanged";
import EmailConfirmation from "../views/EmailConfirmation";
import UserActivation from "../views/UserActivation";
import {useHistory} from "react-router";
import WithAuthWrapper from "../components/WithAuthWrapper";
import SuccessfulActivate from "../views/SuccessfulActivate";


function Auth() {
    let history = useHistory();
    const onclickBackToLogin = (e) => {
        e.preventDefault();
        history.push("/auth/login")
    };

    return (
        <div className="auth-layout pt-2 pt-sm-5 pb-4 pb-sm-5">
            <div className="background"></div>
            <div className="container">
                <div className="row justify-content-center">
                    <Switch>
                        <Route path="/auth/login" render={(props) => <Login {...props} />} />
                        <Route path="/auth/forgot-password" render={(props) => <ResetPassword {...props} onclickBackToLogin={onclickBackToLogin} />} />
                        <Route path="/auth/reset-password" render={(props) => <NewPassword {...props} onclickBackToLogin={onclickBackToLogin} />} />
                        <Route path="/auth/password-changed" render={(props) => <PasswordChanged {...props} onclickBackToLogin={onclickBackToLogin} />} />
                        <Route path="/auth/email-confirmation" render={(props) => <EmailConfirmation {...props} onclickBackToLogin={onclickBackToLogin} />} />
                        <Route path="/auth/user-activate" render={(props) => <UserActivation {...props} onclickBackToLogin={onclickBackToLogin} />} />
                        <Route path="/auth/activate-successful" render={(props) => <SuccessfulActivate {...props} onclickBackToLogin={onclickBackToLogin} />} />
                    </Switch>
                </div>
            </div>
        </div>
    );
}

export default WithAuthWrapper(Auth);
